/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/button-has-type */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import WantToLearnMore from '../../Components/WantToLearnMore';
import NavBarMobileProctoring from '../../Components/NavBarMobileProctoring';

import NavBarVerticalProctoring from '../../Components/NavBarVerticalProctoring';

class TestGuidelines extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">Edvice</title>
          <meta key="og:title" property="og:title" content="Edvice" />
          <meta key="description" name="description" content="Edvice" />
          <meta key="og:description" property="og:description" content="Edvice" />
        </Head>

        <Navbar>Navbar</Navbar>
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./1.png')}
            column="col-xs-10 col-xs-offset-0 col-sm-5 col-sm-offset-2"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Remote Proctored Linguaskill Tests</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobileProctoring />
              <NavBarVerticalProctoring />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="exam-format-content">
                <div className="section__one">
                  <h1>Linguaskill Test Guidelines</h1>
                  <p>
                    Your Institution has chosen the following guidelines to be followed for this
                    test in addition to Proctortrack’s General Guidelines. Keeping these
                    test-specific parameters and whichever general guidelines they don’t override in
                    mind will result in a passing integrity grade.
                  </p>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture006.png')} />
                        <h4>Physical books are not allowed</h4>
                        <p>You will not be allowed to read from physical books during this test.</p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture007.png')} />
                        <h4>Online and Digital resources are now allowed</h4>
                        <p>
                          During this test, referring to digital reading material (PDF, DOCs) or
                          using your computer to search the internet for information is a violation.
                        </p>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture008.png')} />
                        <h4>Digital note-taking is not allowed</h4>
                        <p>
                          During this test, using a separate program like MS Word or other such
                          scratchpads on your computer to write notes is a violation.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture009.png')} />
                        <h4>Handwritten notes / using erasable whiteboard are not allowed</h4>
                        <p>
                          You are not allowed to take handwritten notes / use erasable whiteboards
                          during this test.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0010.png')} />
                        <h4>Headphones are required</h4>
                        <p>Headphones with a microphone are essential for this exam.</p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0011.png')} />
                        <h4>Scanning or taking pictures with your phone not allowed</h4>
                        <p>
                          For this test, you are not allowed to scan or take pictures using your
                          mobile phone.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0012.png')} />
                        <h4>Scanning or uploading documents or not allowed</h4>
                        <p>You may not scan or upload documents.</p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0013.png')} />
                        <h4>Short breaks are allowed</h4>
                        <p>Leaving the webcam frame will not be considered as a violation.</p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0014.png')} />
                        <h4>Food and drinks are allowed</h4>
                        <p>Consuming food and drinks will not be considered as a violation.</p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0015.png')} />
                        <h4>Physical calculators not allowed</h4>
                        <p>You will not be allowed to use a physical calculator for this test.</p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0016.png')} />
                        <h4>On-screen calculators not allowed</h4>
                        <p>You will not be allowed to use an on-screen calculator for this test.</p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0017.png')} />
                        <h4>Printing not allowed</h4>
                        <p>
                          Print attempts cannot be stopped but will be flagged as violation for this
                          test.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0018.png')} />
                        <h4>Multiple monitors not allowed</h4>
                        <p>
                          Using Multiple Monitors during this test will be flagged as a violation.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0019.png')} />
                        <h4>Copy/Paste is not allowed</h4>
                        <p>
                          Clipboard is disabled for this test and Copy/Paste functions are not
                          available.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture0020.png')} />
                        <h4>Print screen disabled</h4>
                        <p>Print screen functionality is not available during this test.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <WantToLearnMore />
        <Footer />
      </React.Fragment>
    );
  }
}
export default TestGuidelines;
